import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import moment from '../../lib/moment.js'
import get from 'lodash/get'
import find from 'lodash/find'
import { FONTS, COLORS } from '../../constants'

export default class ConsentTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
    }
    this.handleClickRow = this.handleClickRow.bind(this)
  }

  handleClickRow(e, edit_id, id) {
    this.props.handleClickEdit(id)
    this.setState({ id: edit_id })
  }

  checkTable(table, d) {
    if (table === 1) return d.company_code
    else if (table === 2) return d.department_code
    else if (table === 3) return d.division_code
    else if (table === 4) return d.emp_code
    else if (table === 5) return d.level_code
    else if (table === 6) return d.lob_code
    else if (table === 7) return d.position_code
    else if (table === 8) return d.team_code
  }

  render() {
    
    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <NewTable bordered hover>
          <Header>
            <tr>
              {
                get(this.props, 'header.length') !== 0 &&
              get(this.props, 'header').map((h, key) =>
                <HeadTable>{ h }</HeadTable>
              )}
            </tr>
          </Header>
          <tbody style={ { width: '100%', display: 'block', maxHeight: 'calc(100vh - 200px)', overflowY: 'scroll' } }>
            {
              get(this.props, 'data.length') !== 0 &&
              get(this.props, 'data').map((d, key) =>

            (<tr style={ { hover: '#E5E5E5', background: (key === this.state.id && get(this.props, 'span')) ? '#E5E5E5' : '' } } onClick={ () => this.handleClickRow(this, key, d._id) }>
              <td>{ get(d, 'title') }</td>
              <td>{ get(d, 'user_type') }</td>
              <td>{ get(d, 'status') === 'true'? 'ACTIVE' : 'INACTIVE' }</td>
              <td>{  get(find(this.props.employeeList, { _id: get(d, 'created_by')}), 'first_name') }
                  {  ' ' + get(find(this.props.employeeList, { _id: get(d, 'created_by')}), 'last_name') + ' ' }
                  ({ get(find(this.props.employeeList, { _id: get(d, 'created_by')}), 'nick_name') })
                  <br></br>
                  { get(d, 'created') ? moment(get(d, 'created')).format('HH:mm - DD/MM/YYYY') : '-' }
              </td>
              <td>{  get(find(this.props.employeeList, { _id: get(d, 'updated_by')}), 'first_name') }
                  {  ' ' + get(find(this.props.employeeList, { _id: get(d, 'updated_by')}), 'last_name') + ' ' }
                  ({ get(find(this.props.employeeList, { _id: get(d, 'updated_by')}), 'nick_name') })
                  <br></br>
                  { get(d, 'updated') ? moment(get(d, 'updated')).format('HH:mm - DD/MM/YYYY') : '-' }
              </td>
            </tr>)
          )}
          </tbody>
        </NewTable>
      </Wrapper>
    )
  }
}

ConsentTable.propTypes = {
  handleClickEdit: PropTypes.func.isRequired,
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const NewTable = styled(Table)`
  background: white;
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  } 
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`



// WEBPACK FOOTER //
// ./src/components/table-consent/index.js